import React, { useState } from 'react'
import { Dialog } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { EmproveDoc } from '@src/types/graphql-types'
import AddToCart from './AddToCart'
import PurchaseTermsAndConditions from './PurchaseTermsAndConditions'

interface PurchaseModalProps {
  open: boolean
  setModalOpen: (boolean) => void
  document: EmproveDoc
}

const useStyles = makeStyles(() => {
  return {
    paper: {
      borderRadius: 0,
      height: '100%',
      margin: 0,
    },
  }
})

const PurchaseModal: React.FC<PurchaseModalProps> = ({
  open,
  setModalOpen,
  document,
}) => {
  const [formPageCount, setFormPageCount] = useState(0)
  const handleClose = () => {
    // @ts-ignore
    if (window.emproveContinue) {
      setFormPageCount(1)
      // @ts-ignore
      window.emproveContinue = false
    } else {
      setModalOpen(false)
      setFormPageCount(0)
    }
  }

  const classes = useStyles()

  return (
    <Dialog open={open} maxWidth="lg" classes={{ paper: classes.paper }}>
      {formPageCount === 1 ? (
        <AddToCart handleClose={handleClose} document={document} />
      ) : (
        <PurchaseTermsAndConditions
          formPageCount={formPageCount}
          setFormPageCount={setFormPageCount}
          handleClose={handleClose}
        />
      )}
    </Dialog>
  )
}

export default PurchaseModal
